<div class="fui-countdown">
  @if (finalCountdownActive) {
    <!-- Final 15s: takes over the entire UI with a single giant digit -->
    <div class="fui-countdown__state">
      @if (event?.image_url) {
        <img [src]="event.image_url" class="fui-countdown__bg" aria-hidden="true" />
        <div class="fui-countdown__scrim"></div>
      }
      <div class="fui-countdown__content">
        <!-- Track by the number so Angular remounts the <div> each tick, replaying the CSS
             enter animation from its huge/faded state instead of running once at 15 and then
             just swapping textContent for the rest of the countdown. -->
        @for (n of [finalCountdownNumber]; track n) {
          <div class="fui-countdown__bignum">{{ n }}</div>
        }
      </div>
    </div>
  } @else if (showingLiveFlash) {
    <div class="fui-countdown__state">
      @if (event?.image_url) {
        <img [src]="event.image_url" class="fui-countdown__bg" aria-hidden="true" />
        <div class="fui-countdown__scrim"></div>
      }
      <div class="fui-countdown__content">
        <div class="fui-countdown__live-flash">LIVE</div>
      </div>
    </div>
  } @else if (event) {
    <div class="fui-countdown__state">
      @if (event.image_url) {
        <img [src]="event.image_url" class="fui-countdown__bg" aria-hidden="true" />
        <div class="fui-countdown__scrim"></div>
      }
      <div class="fui-countdown__content fui-countdown__content--corner">
        @if (showCountdown) {
          <div class="fui-countdown__topline">
            <span class="fui-countdown__eventname">{{ event.title }}</span>
            @if (localDateTime) {
              <span class="fui-countdown__topsep">|</span>
              <span class="fui-countdown__when">{{ localDateTime }}</span>
            }
          </div>
          <div class="fui-countdown__timer">
            <span class="fui-countdown__value">{{ countdownDays | number: "2.0-0" }}</span>
            <span class="fui-countdown__sep">:</span>
            <span class="fui-countdown__value">{{ countdownHours | number: "2.0-0" }}</span>
            <span class="fui-countdown__sep">:</span>
            <span class="fui-countdown__value">{{ countdownMinutes | number: "2.0-0" }}</span>
            <span class="fui-countdown__sep">:</span>
            <span class="fui-countdown__value">{{ countdownSeconds | number: "2.0-0" }}</span>
          </div>
          @if (htmlDescription) {
            <div class="fui-countdown__desc-wrap">
              <div #descText class="fui-countdown__desc" [innerHTML]="htmlDescription | safe: 'html'"></div>
              <!-- Subtle inline "read more" expander, right-aligned under the description. -->
              @if (descriptionOverflows) {
                <button type="button" class="fui-countdown__readmore" (click)="openDescription()">{{ "events.view_more" | translate }}</button>
              }
            </div>
          }
          <!-- Primary CTAs: Sign Up (filled white) + Watch The Trailer (outline), when enabled. -->
          @if (signupEnabled || resolvedPreviewVideoId) {
            <div class="fui-countdown__actions">
              @if (signupEnabled) {
                <button type="button" class="fui-countdown__btn fui-countdown__btn--primary" (click)="openSignup()">{{ signupConfig?.button_text || "Sign Up" }}</button>
              }
              @if (resolvedPreviewVideoId) {
                <button type="button" class="fui-countdown__btn fui-countdown__btn--ghost" (click)="openPreview()">{{ "events.watch_trailer" | translate }}</button>
              }
            </div>
          }
        }
        @if (eventEnded) {
          <div class="fui-countdown__topline">
            <span class="fui-countdown__eventname">{{ event.title }}</span>
            <span class="fui-countdown__topsep">|</span>
            <span class="fui-countdown__when">Ended</span>
          </div>
        }
      </div>
    </div>
  }

  @if (showDescriptionModal) {
    <div class="fui-countdown__modal" (click)="closeDescription()">
      <div class="fui-countdown__modal-panel" (click)="$event.stopPropagation()">
        <button type="button" class="fui-countdown__modal-close" (click)="closeDescription()" aria-label="Close">&times;</button>
        <h2 class="fui-countdown__modal-title">{{ event?.title }}</h2>
        <div class="fui-countdown__modal-body" [innerHTML]="htmlDescription | safe: 'html'"></div>
      </div>
    </div>
  }

  @if (showSignupModal) {
    <!-- Sign-up modal: same overlay as the description modal, but a light panel hosting the shared
         email-capture form. Deliberately NOT closed by a backdrop click (too easy to dismiss a
         half-filled form, incl. mousedown-inside → mouseup-outside) — only the ✕ and Escape close it. -->
    <div class="fui-countdown__modal">
      <div class="fui-countdown__signup-panel">
        <button type="button" class="fui-countdown__signup-close" (click)="closeSignup()" aria-label="Close">&times;</button>
        <fui-embed-signup [config]="signupConfig" [eventId]="signupEventId" [state]="'countdown'"></fui-embed-signup>
      </div>
    </div>
  }

  @if (showPreviewModal && previewEmbedUrl) {
    <!-- Trailer/preview modal: a YouTube embed (id from the ?previewVideo= URL param). -->
    <div class="fui-countdown__modal" (click)="closePreview()">
      <div class="fui-countdown__preview-panel" (click)="$event.stopPropagation()">
        <button type="button" class="fui-countdown__preview-close" (click)="closePreview()" aria-label="Close">&times;</button>
        <div class="fui-countdown__preview-video">
          <iframe [src]="previewEmbedUrl | safe" title="Preview" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  }
</div>
